class CustomPopup extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const overlay = this.querySelector("#popupOverlay");
    const pdpTriggers = document.querySelectorAll('[href="#data-popup-trigger"]');
    const otherTriggers = document.querySelectorAll('[data-popup-trigger]');
    const closeBtns = this.querySelectorAll(".popup-close-button");

    // Show popup on load
    // overlay.style.display = "flex";

    if (pdpTriggers.length > 0) {
      for(let i = 0; i < pdpTriggers.length; i++) {
        pdpTriggers[i]?.addEventListener("click", (e) => {
          overlay.style.display = "flex";
          e.preventDefault();
        });
      }
    }

    if (otherTriggers.length > 0) {
      for(let i = 0; i < otherTriggers.length; i++) {
        otherTriggers[i]?.addEventListener("click", () => {
          overlay.style.display = "flex";
        });
      }
    }

    // Close on button click
    if(closeBtns.length > 0) {
      for(let i = 0; i < closeBtns.length; i++) {
        closeBtns[i]?.addEventListener("click", () => {
          overlay.style.display = "none";
        });
      }
    }

    // Optional: close on outside click
    overlay?.addEventListener("click", (e) => {
      if (e.target === overlay) {
        overlay.style.display = "none";
      }
    });
  }
}

customElements.define("custom-popup", CustomPopup);

